import { render, staticRenderFns } from "./AlertSubmitEvidence.vue?vue&type=template&id=c34f6c2a&scoped=true&"
import script from "./AlertSubmitEvidence.vue?vue&type=script&lang=js&"
export * from "./AlertSubmitEvidence.vue?vue&type=script&lang=js&"
import style0 from "./AlertSubmitEvidence.vue?vue&type=style&index=0&id=c34f6c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34f6c2a",
  null
  
)

export default component.exports